import { buildApiUrl } from "../../services/apiConfig";

/**
 * Service for regression analysis operations
 */
const regressionService = {
  /**
   * Fetch available models
   * @returns {Promise<string[]>} - List of model names
   */
  getModels: async () => {
    const response = await fetch(buildApiUrl("EVAL", '/models'));
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.models || [];
  },

  /**
   * Evaluate regression by uploading a CSV file
   * @param {File} file - The CSV file to upload
   * @param {string} model - The model to use for evaluation
   * @returns {Promise<Object>} - The regression analysis results
   */
  evaluateRegression: async (file, model) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      if (model) formData.append('model', model);

      const response = await fetch(buildApiUrl("EVAL", '/evaluate'), {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Get the response text first
      const responseText = await response.text();
      
      // Replace NaN with null before parsing JSON
      const sanitizedText = responseText.replace(/: NaN/g, ': null');
      
      try {
        // Parse the sanitized JSON
        const data = JSON.parse(sanitizedText);
        return data;
      } catch (parseError) {
        console.error('Error parsing JSON:', parseError);
        console.error('Response text:', responseText);
        throw new Error('Failed to parse server response');
      }
    } catch (error) {
      console.error('Error in regression analysis:', error);
      throw error;
    }
  }
};

export default regressionService;